import styled, { css } from "styled-components";
import { Typography } from "@mui/material";

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const Label = styled(Typography)`
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.white};
`;

export const RequiredMark = styled.span`
  color: ${({ theme }) => theme.colors.red};
`;

export const ErrorText = styled(Typography)`
  color: ${({ theme }) => theme.colors.red};
  margin-top: 4px;
  font-family: ${({ theme }) => theme.fonts.primary};
`;

// 👇 Shared styles with access to hasError
export const BaseFieldStyle = css`
  width: 100%;
  padding: 10px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 300;
  color: ${({ theme }) => theme.colors.darkBlue};
  border-radius: 5px;
  border: ${({ hasError, theme }) =>
    hasError ? `1px solid ${theme.colors.red}` : `1px solid ${theme.colors.lightGrey}`};
  outline: none;
  background-color: white;

  &:focus {
    border-color: ${({ theme }) => theme.colors.paleBlue};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.paleBlue}20;
  }
`;
